import React, { useEffect, useState } from 'react';
import {
  Row,
  Table,
  Typography,
  VertBreadcrumb,
  VertButton,
  VertContainer,
  VertIcon,
  VertSelect,
  VertTypography,
} from '@vertem-core/vertice-ds';
import { Col } from '@vertem-core/vertice-ds';
import '../../Assets/styles/default/pages/listSolicitation/ListSolicitation.less';
import TitleForm from './components/TitleForm/TitleForm';
import { FileOutlined, RightOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { loadListSolicitation } from 'redux/Reducers/Spot/spotListSolicitation';
import { useNavigate } from 'react-router';
import {
  openModal as openBalloon,
  closeModal as closeBalloon,
} from 'redux/Reducers/PopBallon/VertemGiftSlice';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import { useMediaQuery } from 'react-responsive';
import { FaEdit, FaEye } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import BalloonModal from '../../components/PopBallon/ShowcasePopBallon/BallonModal';
import { fetchAvailableBallons } from '../../redux/Reducers/PopBallon/VertemGiftApi';
import useActiveCampaign from 'Hooks/useVertemGift';
import ynToBool from 'Utils/ynToBool';

let checkBallonGetInListSolicitation = false;
const typeStatus = (type, role) => {
  switch (type) {
    case 1:
      return (
        <Typography.Text type="warning">Aguardando cotacão</Typography.Text>
      );
    case 2:
      return (
        <Typography.Text type="warning">
          {role ? 'Pendente - PMO' : 'Pendente Syngenta'}
        </Typography.Text>
      );
    case 3:
      return (
        <Typography.Text type="warning">
          {role ? 'Pendente - Líder' : 'Pendente Syngenta'}
        </Typography.Text>
      );
    case 4:
      return (
        <Typography.Text type="warning">Aguardando aprovação</Typography.Text>
      );
    case 5:
      return <Typography.Text type="danger">Cancelado</Typography.Text>;
    case 6:
      return <Typography.Text type="success">Aprovado</Typography.Text>;
    case 10:
      return (
        <Typography.Text type="warning">
          {role ? 'Confirmação Líder' : 'Pendente Syngenta'}
        </Typography.Text>
      );
    default:
      return <Typography.Text type="warning">Pendente</Typography.Text>;
  }
};

let modalBalloonShow = false;
const ListSolicitation = () => {
  const dispatch = useDispatch();
  const { isManager, isPMO, isLead, getRedemptionSpotGroups } =
    useParticipantSubSegment();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoadingBalloonFetch, setIsLoadingBalloonFetch] = useState(true);
  const { isModalOpen, availableBallons, isLoaded } = useSelector(
    ({ VertemGift }) => VertemGift
  );
  const { loading, dataSolicitation, totalCount } = useSelector(
    (state) => state.SpotListSolicitation
  );
  const queryParams = new URLSearchParams(location.search);
  const { isCallingActiveVertemGift, isCampaignActive } = useActiveCampaign();

  const handleModalClose = () => {
    dispatch(closeBalloon());
  };

  const handleModalShow = () => {
    dispatch(openBalloon());
  };

  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });
  const [status, setStatus] = useState('0');
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    user: { profile, access_token },
  } = userInfos;

  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const currentParticipantId = userProfile['custom:participant_id'];

  const breadcrumbMock = [
    {
      title: 'Início',
      path: '/',
    },
    {
      title: 'Lista de Solicitações',
      path: '/list-redemptions',
    },
  ];

  useEffect(() => {
    if (modalBalloonShow) modalBalloonShow = false;
    if (checkBallonGetInListSolicitation)
      checkBallonGetInListSolicitation = false;
  }, [location]);

  useEffect(() => {
    if (userInfos?.isLoaded) {
      dispatch(
        loadListSolicitation({
          status,
          isPMO,
          isLead,
          headers: config,
        })
      );
    }
  }, [userInfos, status]);

  const linkToRedemption = (item) => {
    if (isPMO || isManager || isLead) {
      if (item.type === 3) {
        navigate(`/approve-redemption-hierarchy/${item.id}`);
      } else if (item.type == 4) {
        navigate(`/approve-redemption-quote/${item.id}`);
      } else {
        navigate(`/approve-redemption/${item.id}`);
      }
    } else {
      if (
        item.redemptionStatusId < 4 ||
        item.redemptionStatusId === 5 ||
        item.redemptionStatusId === 6
      ) {
        navigate(`/view-redemption/${item.id}`);
      } else {
        if (item.type === 3) {
          navigate(`/approve-redemption-hierarchy/${item.id}`);
        } else if (item.type == 4) {
          navigate(`/approve-redemption-quote/${item.id}`);
        } else {
          navigate(`/approve-redemption/${item.id}`);
        }
      }
    }
  };
  const columns = [
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      render: (_, { date }) => (
        <Typography.Text>
          {new Intl.DateTimeFormat('pt-BR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }).format(new Date(date))}
        </Typography.Text>
      ),
      defaultSortOrder: 'descend',
      width: '10%',
    },

    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      render: (_, { id }) => <Typography.Text>#{id}</Typography.Text>,
      sorter: (a, b) => a.id - b.id,
      sortDirections: ['descend', 'ascend'],
      width: '10%',
    },
    {
      title: 'Valor',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      render: (_, { totalPrice }) => (
        <Typography.Text>
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(totalPrice)}
        </Typography.Text>
      ),
      width: '16%',
    },
    {
      title: 'Solicitante',
      dataIndex: 'managerName',
      key: 'managerName',
      width: '16%',
      render: (_, { managerName }) => (
        <Typography.Text>{managerName || '-'}</Typography.Text>
      ),
    },
    {
      title: 'Participante',
      dataIndex: 'participantName',
      key: 'participantName',
      sorter: (a, b) => a.participantName.localeCompare(b.participantName),
      sortDirections: ['descend', 'ascend'],
      width: '16%',
    },
    {
      title: 'Tipo de Solicitação',
      dataIndex: 'type',
      key: 'type',
      render: (_, { type }) => (
        <Typography.Text>
          {type === 1
            ? 'Spot'
            : type === 2
            ? 'Spot Hierarquia'
            : type === 3
            ? 'Hierarquia'
            : 'Cotação'}
        </Typography.Text>
      ),
      sortDirections: ['descend', 'ascend'],
      width: '16%',
    },
    {
      title: 'Status',
      dataIndex: 'redemptionStatusId',
      key: 'redemptionStatusId',
      render: (_, { redemptionStatusId }) =>
        typeStatus(redemptionStatusId, isPMO || isManager || isLead),
      sorter: (a, b) => a.redemptionStatusId - b.redemptionStatusId,
      sortDirections: ['descend', 'ascend'],
      filters: [
        {
          text: 'Aguardando cotação',
          value: 1,
        },
        {
          text: 'Pendente - PMO',
          value: 2,
        },
        {
          text: 'Pendente - Gestor',
          value: 3,
        },
        {
          text: 'Aguardando aprovação',
          value: 4,
        },
        {
          text: 'Cancelado',
          value: 5,
        },
        {
          text: 'Aprovado',
          value: 6,
        },
        {
          text: 'Confirmação Líder',
          value: 10,
        },
      ],
      onFilter: (value, record) => record.redemptionStatusId === value,
      width: '16%',
    },

    {
      title: mediaQuery ? '' : 'Ações',
      dataIndex: 'type',
      key: 'type',

      render: (_, action) => {
        const isAccessParticipantToEdit =
          String(action.participantId) == currentParticipantId &&
          action.sendToOperation;
        return (
          <div className="vert-product-table-spot">
            <VertButton
              type="default"
              shape={'round'}
              size={'small'}
              disabled={
                action.type === 4 &&
                action.redemptionStatusId === 1 &&
                !isPMO &&
                !isManager &&
                !isLead
              }
              onClick={() => {
                linkToRedemption(action);
              }}
              icon={<FaEye />}
            />
          </div>
        );
      },
      width: '16%',
    },
  ];

  const handleOption = (value) => {
    setStatus(value);
  };

  const validOption =
    isPMO || isLead || isManager
      ? [
          {
            label: 'Aguardando cotação',
            value: '1',
          },
          {
            label: 'Pendente - PMO',
            value: '2',
          },
          {
            label: 'Pendente - Gestor',
            value: '3',
          },
          {
            value: '10',
            label: 'Confirmação Líder',
          },
        ]
      : [];

  useEffect(() => {
    if (ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT) && isCampaignActive) {
      if (
        queryParams.get('redemptionSuccess') === 'true' &&
        availableBallons &&
        availableBallons.length > 0 &&
        !modalBalloonShow &&
        isLoaded
      ) {
        modalBalloonShow = true;
        setTimeout(() => {
          handleModalShow();
        }, 2000);
      }
    }
  }, [queryParams, availableBallons, isLoaded, isCampaignActive]);

  const getBalloonsData = async () => {
    await dispatch(fetchAvailableBallons());
    setIsLoadingBalloonFetch(false);
  };

  useEffect(() => {
    if (ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT) && isCampaignActive) {
      if (!checkBallonGetInListSolicitation) {
        checkBallonGetInListSolicitation = true;
        getBalloonsData();
      }
    }
  }, [isLoaded, isCampaignActive]);

  useEffect(() => {
    if (isLoaded && isLoadingBalloonFetch) {
      setIsLoadingBalloonFetch(false);
    }
  }, [isLoaded, isLoadingBalloonFetch]);

  return (
    <>
      <VertContainer fluid className="list-solicitation">
        <VertContainer spacingX="regular" spacingY="small">
          <Row className="extract-page-breadcrumb" align="middle" gutter={6}>
            <VertBreadcrumb
              hasBackButton={true}
              separator={<VertIcon component={RightOutlined} />}
              items={breadcrumbMock}
            />
          </Row>
          <Row gutter={0} verticalSpacing="regular">
            <Col span={12}>
              <VertTypography.Title>Lista de Solicitações</VertTypography.Title>
              <VertTypography.Text>
                Visualize o histórico de suas solicitações.
              </VertTypography.Text>
            </Col>
          </Row>
          <Row
            gutter={[16, 16]}
            verticalSpacing="regular"
            justify="space-between"
          >
            <Col span={12}>
              <TitleForm icon={<FileOutlined />} title="Solicitações" />
            </Col>
            <Col span={12} md={6}>
              <VertSelect
                value={status}
                onChange={handleOption}
                options={[
                  {
                    label: 'Visualizar Todos',
                    value: '0',
                  },
                  ...validOption,

                  {
                    value: '4',
                    label: 'Aguardando aprovação',
                  },
                  {
                    label: 'Aprovados',
                    value: '6',
                  },
                  {
                    label: 'Cancelados',
                    value: '5',
                  },
                ]}
                placeholder="Visualizar Todos"
              />
            </Col>
          </Row>
          {(getRedemptionSpotGroups() || isPMO || isLead || isManager) && (
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifySelf: 'flex-end',
                  }}
                >
                  <VertButton
                    type="default"
                    onClick={() => navigate('/spot-redemption')}
                  >
                    Nova Solicitação
                  </VertButton>
                </div>
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]} verticalSpacing="regular">
            <Table
              columns={columns}
              dataSource={dataSolicitation}
              pagination={{
                pageSize: 10,
                total: totalCount,
              }}
              size="small"
              loading={loading}
              bordered
              tableLayout="auto"
              sticky
              locale={{
                emptyText: 'Nenhum resultado encontrado',
              }}
              scroll={{ x: 1000 }}
            />
          </Row>
        </VertContainer>
      </VertContainer>

      {isModalOpen &&
        availableBallons &&
        availableBallons.length > 0 &&
        isLoaded &&
        !isLoadingBalloonFetch && (
          <>
            <BalloonModal
              balloon={availableBallons[0]}
              onClose={handleModalClose}
            />
          </>
        )}
    </>
  );
};

export default ListSolicitation;
